const circularIncrement = (i, l) => {
  if (i+1 >= l) {
    return 0
  }
  return i+1
}

export default circularIncrement;